export default __webpack_public_path__ + "static/media/icon-radio-input-checked-v2.24452143.svg";